import { HomePlusIcon } from './HomePlusIcon';

/**
 * author: Peter Noble
 * id E844FA32-E45E-4D71-B74C-34DFAD7F6830
 * name home-plus
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-plus.svg
 * tags
 * - Home Automation 
 */
export const HomeAddIcon = HomePlusIcon;
export default HomeAddIcon